
import "../scss/main.scss"

import { initModals } from "./modules/modal.js"
import { initLightbox } from "./modules/lightbox.js"
import { initReadmore } from "./modules/readmore.js"
import { initNav } from "./modules/nav.js"
import { initShare } from "./modules/share.js"
import { initForms } from "./modules/forms.js"

initNav()
initModals()
initLightbox()
initReadmore()
initShare()
initForms()
